export class User {
    id: number;
    password: string;
    firstName: string;
    lastName: string;
    access_token?: string;
    role?: any;
    userId: number;
    userName:string;
    email: string;
}

export class CreateModifyUser{
    FirstName:string;
    LastName:string;
    Username:string;
    Password:string;
    Email:string;
    UserId:string;
    UserGUID:string;
    lstRoles:any;
    Createdby:any;
}